import React, { createContext } from 'react'
import UseList from '../hooks/UseList'

// Creates a context that can be consumed by the listing grid
const ListContext = createContext();

function ListProvider({ children, startCategory, startSubCategory, startSearchText, startLocation }) {
  const {
    category,
    setCategory,
    subCategory,
    setSubCategory,
    searchText,
    setSearchText,
    location,
    setLocation,
    isQueenOfQuality,
    setIsQueenOfQuality,
    resultsCount,
    isActiveEntriesLoaded,
    filteredEntries,
    isEntriesFiltered,
    sortDirection,
    setSortDirection,
    displayOption,
    setDisplayOption,
    isPerformanceProgram,
    setIsPerformanceProgram
  } = UseList(startCategory, startSubCategory, startSearchText, startLocation);

  return (
    <ListContext.Provider
      value={{
        category,
        setCategory,
        subCategory,
        setSubCategory,
        searchText,
        setSearchText,
        location,
        setLocation,
        isQueenOfQuality,
        setIsQueenOfQuality,
        resultsCount,
        isActiveEntriesLoaded,
        filteredEntries,
        isEntriesFiltered,
        sortDirection,
        setSortDirection,
        displayOption,
        setDisplayOption,
        isPerformanceProgram,
        setIsPerformanceProgram
      }}>
      {children}
    </ListContext.Provider>
  )
}

export { ListContext, ListProvider }